import intersection from 'lodash/intersection';
import { formValueSelector } from 'redux-form';

import {
  DOB_FIELD_KEYS,
  NAME_FIELD_KEYS,
  ADDRESS_FIELD_KEYS,
  ID_FIELD_KEYS,
} from 'apps/age_verification/components/forms/validations';
import { smoothScrollTo } from 'common/utils';

export const getConfirmValues = (state, formName) => {
  const selector = formValueSelector(formName);
  return {
    first_name: selector(state, 'first_name'),
    last_name: selector(state, 'last_name'),
    year: selector(state, 'year'),
    month: selector(state, 'month'),
    day: selector(state, 'day'),
  };
};

export const getSsnOptoutValue = (state, formName) =>
  formValueSelector(formName)(state, 'national_id_number_optout') || false;

export const getDobValues = (state, formName) => {
  const selector = formValueSelector(formName);
  return {
    year: selector(state, 'year'),
    month: selector(state, 'month'),
    day: selector(state, 'day'),
  };
};

export const getReduxFormErrorList = reduxFormValidations => {
  const errorKeys = [];
  // Find all form fields that have an existing validation error
  for (const key of Object.keys(reduxFormValidations)) {
    if (reduxFormValidations[key] !== undefined) {
      errorKeys.push(key);
    }
  }
  return errorKeys;
};

export const scrollToDataMatchFormError = reduxFormValidations => {
  const errorKeys = getReduxFormErrorList(reduxFormValidations);
  if (errorKeys.length === 0) {
    return;
  }
  // Ordering from top to bottom of data match input fields
  // Scroll to the first section that contains a redux form validation error
  if (intersection(errorKeys, Object.keys(DOB_FIELD_KEYS)).length) {
    smoothScrollTo('.DobFieldGroup');
  } else if (intersection(errorKeys, Object.keys(NAME_FIELD_KEYS)).length) {
    smoothScrollTo('.NameFieldGroup');
  } else if (intersection(errorKeys, Object.keys(ADDRESS_FIELD_KEYS)).length) {
    smoothScrollTo('.AddressFieldGroup');
  } else if (intersection(errorKeys, Object.keys(ID_FIELD_KEYS)).length) {
    smoothScrollTo('.AddressForm__ssn');
  }
};
